<template>
  <div class="ds-control ds-no-padding ds-design-img dsf-image" :style="{ 'text-align': align }">
    <template v-if="src">
      <el-image :style="sizeStyle" :src="$src" :fit="fit" :alt="alt" :referrer-policy="referrerPolicy" :lazy="lazy" :scroll-container="scrollContainer" :preview-src-list="previewSrcList" :z-index="zIndex" @load="$emit('load', $event)" @error="$emit('error', $event)">
        <template #placeholder>
          <slot name="placeholder">
            <i class="el-icon-loading"></i>
          </slot>
        </template>
        <template #error>
          <slot name="error">
            <template v-if="failDataObj">
              <img v-if="failDataObj.isImage" class="dsf-image-fail" :src="failDataObj.value" alt="加载异常" />
              <span v-else class="dsf-image-fail" v-html="failDataObj.value"></span>
            </template>
          </slot>
        </template>
      </el-image>
    </template>
    <template v-else>
      <slot name="empty">
        <template v-if="emptyDataObj">
          <img v-if="emptyDataObj.isImage" class="dsf-image-empty" alt="图片缺失" :src="emptyDataObj.value" />
          <span v-else class="dsf-image-empty" v-html="emptyDataObj.value"></span>
        </template>
      </slot>
    </template>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfImage",
  mixins: [$mixins.control],
  ctrlCaption: "图片加载",
  props: {
    // 图片源，同原生
    src: {
      type: String,
      default: ""
    },
    fit: {
      type: String,
      default: "cover"
    },
    width: {
      type: [Number, String],
      default: "100%"
    },
    height: {
      type: [Number, String],
      default: "auto"
    },
    align: {
      type: String,
      default: "center"
    },
    emptyData: {
      type: String,
      default: "暂无图片"
    },
    failData: {
      type: String,
      default: "加载异常"
    },
    // 原生 alt
    alt: {
      type: String,
      required: false
    },
    // 原生 referrerPolicy
    referrerPolicy: {
      type: String,
      required: false
    },
    // 是否开启懒加载
    lazy: {
      type: Boolean,
      default: false
    },
    // 开启懒加载后，监听 scroll 事件的容器
    // 最近一个 overflow 值为 auto 或 scroll 的父元素
    scrollContainer: {
      type: [String, HTMLElement],
      required: false
    },
    // 开启图片预览功能
    previewSrcList: {
      type: Array,
      required: false
    },
    // 	设置图片预览的 z-index
    zIndex: {
      type: Number,
      required: false
    }
  },
  computed: {
    defaultImg() {
      return this.errorSrc || dsf.config.setting_public_card_default_img;
    },
    emptyDataObj() {
      let str = this.emptyData;
      if (str) {
        return {
          value: str,
          isImage: this.isImageFun(str)
        };
      } else {
        return null;
      }
    },
    failDataObj() {
      let str = this.failData;
      if (str) {
        return {
          value: str,
          isImage: this.isImageFun(str)
        };
      } else {
        return null;
      }
    },
    sizeStyle() {
      // 图片尺寸样式
      return {
        width: this.width,
        height: this.height
      };
    },
    $src(){
      return dsf.url.getWebPath(this.src)
    }
  },
  methods: {
    isImageFun(str) {
      return /\.(jpeg|jpg|gif|png)$/.test(str);
    }
  }
});
</script>
